import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export interface CreateLocationBody {
  id: string;
}

export const createLocation = async (warehouseId: string, body: CreateLocationBody, callback: CallbackObject<void>) => {
  try {
    await instance.post(`/warehouse/warehouses/${warehouseId}/locations`, body);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
